import { Box, Skeleton } from '@mui/material';
import { Card, CardTitle } from '@apigrowfinance/pbolt-card';
import IllustratedMessage from '@apigrowfinance/pbolt-illustrated-message';
import { RiFundsLine } from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { GetCardControlsConditionsResponse } from '@clients/domains/flexControls/flexControlAccountClient';
import ControlConditionsBlock from '@components/controlDetails/components/conditionsBlock/ControlConditionsBlock';

export type ControlConditionsProps = {
    cardControlRules: GetCardControlsConditionsResponse[];
    isLoading: boolean;
    noColumnsPerRow: number;
};

const ControlConditions = ({
    cardControlRules = [],
    isLoading,
    noColumnsPerRow,
}: ControlConditionsProps) => {
    if (!isLoading && cardControlRules.length === 0) {
        return (
            <Card>
                <Box sx={{ mt: 2.5 }} data-testid="no-charge-plans">
                    <IllustratedMessage
                        icon={<RiFundsLine />}
                        messageMain={
                            <FormattedMessage
                                id="ControlConditions.noControlsTitle"
                                defaultMessage="No control conditions"
                            />
                        }
                        messageSub={
                            <FormattedMessage
                                id="ControlConditions.noControlsDescription"
                                defaultMessage="No conditions have been added to this permission"
                            />
                        }
                    />
                </Box>
            </Card>
        );
    }

    // loading so to show the skeleton, we need to add a dummy now
    if (isLoading && cardControlRules.length === 0) {
        cardControlRules = [{} as GetCardControlsConditionsResponse];
    }

    return (
        <>
            <Card isBottomRadiusBorder={false} isIndented>
                <CardTitle>
                    {isLoading ? (
                        <Skeleton width={90} data-testid="title-loading" />
                    ) : (
                        <FormattedMessage
                            id="CardControls.conditions"
                            defaultMessage="Conditions"
                        />
                    )}
                </CardTitle>
            </Card>
            <ControlConditionsBlock
                cardControlRules={cardControlRules}
                isLoading={isLoading}
                noColumnsPerRow={noColumnsPerRow}
            />
        </>
    );
};

export default ControlConditions;
